import BasePageSliderPage from './basePageSliderPage/basePageSliderPage';

export { BasePageSliderPage }
export * from './nativeHeader';
